import { Project } from '@constants/router.const';
import { Ng2StateDeclaration } from '@uirouter/angular';

export const CONFIGURATION_MODULE_STATE: Ng2StateDeclaration = {
  name: `dice.${Project.CONFIGURATION}.**`,
  url: '/configuration',
  loadChildren: () =>
    import('@dice/router/modules/configuration/configuration.module').then((m) => m.ConfigurationModule),
};

export const APP_STATES = [CONFIGURATION_MODULE_STATE];
